module.exports = __webpack_public_path__ + "static/iconEmail-cc01f70f4ff90861fd136182a99c0f24.png";